import { ReactComponent as Icon } from '../../assets/icons/homeIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
